import ImageLoader from './image-loader'

document.addEventListener('DOMContentLoaded', () => {
  const counters = $('.char-counter')

  counters.each((_, root) => {
    const $root = $(root)

    const updateCounter = () => {
      const v = $root.find('input').val() || ''

      $root.find('.char-counter__counter').text(v.length)
    }

    $root.find('input').on('"propertychange change click keyup input paste', updateCounter)
    updateCounter()
  })

  const $root = $('.blog-form')
  if (!$root) {
    return
  }

  const $editor = $root.find('.blog-form__content')

  // --
  // Spinner
  // --
  const $loadSpinner = $('.blog-form__spinner')

  const showSpinner = () => {
    $loadSpinner.show()
  }

  const hideSpinner = () => {
    $loadSpinner.hide()
  }

  // --
  // Image loader
  // --
  const $fileDialog = $('.blog-form__input-file')

  const insertText = newText => {
    $editor.focus()
    const text = $editor.val() || ''
    let start = $editor.prop('selectionStart') || 0
    const end = $editor.prop('selectionEnd') || start

    $editor.val(text.slice(0, start) + newText + text.slice(end))
  }

  const handleLoadFile = req => {
    insertText(`<img src="${req.url}">\n`)
    hideSpinner()
    $editor.trigger('keyup')
  }

  const handleUploading = () => {
    showSpinner()
  }

  const imgLoader = new ImageLoader($editor, {
    type: 'blog',
    onUploading: handleUploading,
    onUpload: handleLoadFile,
    postId: $('.data-store').data('post'),
  })

  $fileDialog.on('change', function (e) {
    const files = e.target.files

    imgLoader.loadFile(files)
  })

  // --
  // Preview
  // --
  const $preview = $('.preview-image')
  let imageList = []

  $preview.on('click', '.preview-image__wrapper', function (e) {
    if (!confirm('Remove the image?')) {
      return
    }

    const imgSrc = '/' + e.target.children[0].src.split('/').splice(3).join('/')
    const imgCode = `<img src="${imgSrc}">`

    const text = $editor.val() || ''
    const start = text.indexOf(imgCode)

    if (start === -1) return

    $editor.val(text.slice(0, start) + text.slice(start + imgCode.length))
    imageList.splice(imageList.indexOf(imgCode), 1)
    $(this).remove()
    imgLoader.removeFile(imgSrc)
  })

  const addPreview = link => {
    const imageInText = `<img src="${link}">`

    imageList.push(imageInText)

    $preview.append(
      `<div class="preview-image__wrapper">
        <img src="${link}"
          style="object-fit: cover;" class="preview-image__item">
      </div>`,
    )
  }

  const removePreview = tag => {
    $('.preview-image__wrapper').each((i, item) => {
      const imgSrc = '/' + item.children[0].src.split('/').splice(3).join('/')
      const imgCode = `<img src="${imgSrc}">`

      if (tag === imgCode) {
        $(item).remove()
      }
    })
  }

  const checkImagesInCode = text => {
    const regexp = /<img .*?>/g
    let tag = []
    let allTags = []

    while ((tag = regexp.exec(text))) {
      allTags.push(tag[0])
    }

    let tempImageList = []
    imageList.forEach(item => {
      if (allTags.indexOf(item) === -1) {
        const regexpSrc = /src\s*=\s*['\"]([^'\"]*?)['\"]/
        const imgSrc = regexpSrc.exec(item)[1]

        imgLoader.removeFile(imgSrc)

        removePreview(item)
      } else {
        tempImageList.push(item)
      }
    })

    imageList = tempImageList

    allTags.forEach(item => {
      if (imageList.indexOf(item) === -1) {
        const regexpSrc = /src\s*=\s*['\"]([^'\"]*?)['\"]/
        const imageSrc = regexpSrc.exec(item)[1]

        addPreview(imageSrc)
      }
    })
  }

  checkImagesInCode($editor.val() || '') // generate previews on page load

  // --
  // Editor
  // --
  $editor.on('keyup', e => {
    const text = $editor.val() || ''
    checkImagesInCode(text)
  })

  // Allow to insert custom tags using helpers
  $root.on('click', '.blog-form__element', function (e) {
    e.preventDefault()
    e.stopPropagation()
    $editor.focus()

    const text = $editor.val() || ''
    const start = $editor.prop('selectionStart') || 0
    const end = $editor.prop('selectionEnd') || start

    // Tag and attributes
    const tag = $(this).data('tag')
    const tagAttrs = tag === 'a' ? ' href="" ' : ''

    if (tag === 'img') {
      $fileDialog.trigger('click')
      return
    }

    $editor.val(
      text.slice(0, start) +
        `<${tag}${tagAttrs}>${text.slice(start, end)}</${tag}>` +
        text.slice(end),
    )
  })
})
